/* ============================================================
   adv-v1 — behaviours re-implemented from the Claude Design export
   (its own script was read, then discarded). Namespace: lpa1.
     1. Evergreen countdown (offer bar pills and the offer card line): counts
        down from the section's minutes and restarts at zero. Every timer with
        the same length shares one end time, so the bar and the card always
        agree, and the end time survives a reload within the tab session
        (sessionStorage, guarded).
     2. Review cards on a phone: the previous / next buttons over each photo
        scroll one card (card width + gap), arrow keys work when the row has
        focus, smooth unless the visitor asks for reduced motion. On desktop
        the three cards sit in one row and the buttons are hidden by CSS.
   Rebinds on shopify:section:load so the theme editor never double-binds.
   ============================================================ */
(function () {
  'use strict';
  var BOUND = 'lpa1Bound';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ends = {};

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function endFor(mins) {
    var key = 'lpa1-timer-' + mins;
    var now = Date.now();
    var end = ends[key] || 0;
    if (!end) {
      try { end = parseInt(window.sessionStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
    }
    if (!end || end <= now) {
      end = now + mins * 60 * 1000;
      try { window.sessionStorage.setItem(key, String(end)); } catch (e) {}
    }
    ends[key] = end;
    return end;
  }

  function initTimer(el) {
    if (el.dataset[BOUND]) return;
    el.dataset[BOUND] = '1';
    var mins = parseInt(el.getAttribute('data-minutes'), 10);
    if (!(mins > 0)) mins = 60;
    var hh = el.querySelector('[data-lpa1-hh]');
    var mm = el.querySelector('[data-lpa1-mm]');
    var ss = el.querySelector('[data-lpa1-ss]');
    function tick() {
      var left = Math.max(0, Math.round((endFor(mins) - Date.now()) / 1000));
      if (hh) hh.textContent = pad(Math.floor(left / 3600));
      if (mm) mm.textContent = pad(Math.floor((left % 3600) / 60));
      if (ss) ss.textContent = pad(left % 60);
    }
    tick();
    el._lpa1Timer = window.setInterval(tick, 1000);
  }

  function initTrack(track) {
    if (track.dataset[BOUND]) return;
    track.dataset[BOUND] = '1';
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 14;
      return card.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    Array.prototype.forEach.call(track.querySelectorAll('[data-lpa1-prev]'), function (b) {
      b.addEventListener('click', function () { go(-1); });
    });
    Array.prototype.forEach.call(track.querySelectorAll('[data-lpa1-next]'), function (b) {
      b.addEventListener('click', function () { go(1); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  }

  function init(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-lpa1-timer]'), initTimer);
    Array.prototype.forEach.call(s.querySelectorAll('[data-lpa1-track]'), initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-lpa1-timer]'), function (el) {
      if (el._lpa1Timer) window.clearInterval(el._lpa1Timer);
    });
  });
})();
